import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from '../../../helpers/modal.tokens';

@Component({
  selector: 'app-team-statements-modal',
  templateUrl: './team-statements-modal.component.html',
  styleUrls: ['./team-statements-modal.component.scss']
})
export class TeamStatementsModalComponent {

  constructor(@Inject(MODAL_DATA) public config: { statements: any[] },
              private dialogRef: MatDialogRef<any>) { }

  close() {
    this.dialogRef.close();
  }
}
